import { render, staticRenderFns } from "./listfooter.vue?vue&type=template&id=310c8330&"
import script from "./listfooter.vue?vue&type=script&lang=js&"
export * from "./listfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports